export default __webpack_public_path__ + "static/media/twitter.50ce32c1.svg";